<template>
  <div>
    <div id="dashboard-container" />
  </div>
</template>

<script>
import axios from 'axios';
import { DatabricksDashboard } from '@databricks/aibi-client';

export default {
  data() {
    return {
      dashboardKey: this.$route.meta.dashboardKey || 'missing!',
      databricksWorkspaceURL: '',
      databricksWorkspaceId: '',
      dashboardId: '',
      token: '',
    };
  },

  async mounted() {
    console.log(this.dashboardKey);

    const [token, dashboardDetails] = await Promise.all([
      this.refreshToken(),
      axios.get('/api/dashboard-databricks/dashboard', {
        params: {
          dashboardKey: this.dashboardKey,
        },
      }),
    ]);
    this.token = token;
    this.databricksWorkspaceHostname = dashboardDetails.data.databricksWorkspaceHostname;
    this.databricksWorkspaceId = dashboardDetails.data.databricksWorkspaceId;
    this.dashboardId = dashboardDetails.data.dashboardId;

    this.$nextTick(() => {
      // Instantiate and initialize the dashboard using databricks aibi-client library
      // The dashboard is embedded in an iframe and the library handles the rendering
      // By providing the `getNewToken` function, the library also knows how to refresh the token (by default expires in 1 hour)
      this.dashboard = new DatabricksDashboard({
        workspaceId: this.databricksWorkspaceId,
        instanceUrl: `https://${this.databricksWorkspaceHostname}/`,
        dashboardId: this.dashboardId,
        token: this.token,
        container: document.getElementById('dashboard-container'),
        colorScheme: 'light', // match better pricing's design
        // The refresh_token endpoint mints a new token using our databricks service principal secret
        // so it can be used to access the dashboard without the application user having to login to our databricks instance
        getNewToken: this.refreshToken,
      });

      this.dashboard.initialize();
    });
  },
  destroyed() {
    // Remove the dashboard from the DOM on path change
    this.dashboard.destroy();
  },
  methods: {
    async refreshToken() {
      const response = await axios.get('/api/dashboard-databricks/embed-token', {
        params: {
          dashboardKey: this.dashboardKey,
        },
      });
      const token = response.data.access_token.trim();
      return token;
    },
  },
};
</script>

<style>
/*
 * Pull back the 12px padding added by the outer v-container fluid in app.vue so the
 * dashboard container edge-to-edge fills the content area.
 *
 * Height uses `calc(100vh - 104px)` where 104px is the combined padding on the main v-main container
 * accounting for 64px of navbar's height and 40px of footer's height.
 * This height then fills the remaining viewport without overflowing, eliminating the
 * page-level scrollbar. The iframe then scrolls internally (single scrollbar).
 */
#dashboard-container {
  margin: -12px;
  padding-top: 12px;
  height: calc(100vh - 104px);
  overflow: hidden;
}

#dashboard-container > iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
